import { baseUniDriverFactory } from '../../testkitUtils/unidriver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { fieldsetDriverFactory } from '../internal/Fieldset/Fieldset.driver';
import {
  BOX_SELECTION_DATA_ATTRIBUTES,
  BOX_SELECTION_DATA_HOOKS,
} from './dataHooks';
import { BoxSelectionSelectionType } from './types';

export const boxSelectionDriverFactory = (base: UniDriver) => {
  const boxOptionDataHook = `[data-hook=${BOX_SELECTION_DATA_HOOKS.BOX_SELECTION_OPTION}]`;
  const fieldsetDriver = fieldsetDriverFactory(base);
  const getOptionById = async (id: string) => base.$(`[id="${id}"]`);
  const getOptionByDataId = async (id: string) => base.$(`[data-id="${id}"]`);
  const boxSelectionSuffixDataHook = `[data-hook=${BOX_SELECTION_DATA_HOOKS.BOX_SELECTION_SUFFIX}]`;

  return {
    ...baseUniDriverFactory(base),
    option: {
      getOptionById,
    },
    async getOptionsCount() {
      return base.$$(boxOptionDataHook).count();
    },
    async isChecked(id: string) {
      const option = await getOptionById(id);
      const isChecked = await option._prop('checked');
      return isChecked;
    },
    async isDisabled(id: string) {
      const option = await getOptionById(id);
      const isDisabled = await option._prop('disabled');
      return isDisabled;
    },
    async isUnavailable(id: string) {
      const option = await getOptionByDataId(id);
      const isUnavailable =
        (await option.attr(BOX_SELECTION_DATA_ATTRIBUTES.UNAVAILABLE)) ===
        'true';
      return isUnavailable;
    },
    async getNativeSelector(id: string) {
      const option = await getOptionByDataId(id);
      return (await option.attr(
        BOX_SELECTION_DATA_ATTRIBUTES.NATIVE_SELECTOR,
      )) as BoxSelectionSelectionType;
    },
    async hasError() {
      return fieldsetDriver.hasError();
    },
    async getErrorMessageText() {
      return fieldsetDriver.getErrorMessage();
    },
    getSuffix: () => base.$(boxSelectionSuffixDataHook),
  };
};

export type BoxSelectionDriver = ReturnType<typeof boxSelectionDriverFactory>;
